<template>
  <div class="form-elements">
    <div class="row">
      <div class="flex xs12">
        <va-card :title="$t('menu.mounting_flow')">
          <form @submit.prevent>
            <div class="row">
              <div class="flex md4 sm6 xs12">
                <va-select
                  :label="$t('tables.mounting_flow.status')"
                  v-model="order_step.status"
                  keyBy="id"
                  textBy="name"
                  :options="statuses"
                  searchable
                />
              </div>

              <div class="flex md4 sm6 xs12">
                <va-select
                  :label="$t('tables.mounting_flow.role')"
                  v-model="order_step.role"
                  keyBy="id"
                  textBy="name"
                  :options="roles"
                  searchable
                />
              </div>

               <div class="flex md4 sm6 xs12">
                <va-input
                  :label="$t('tables.mounting_flow.step_sequence')"
                  v-model="order_step.step_sequence"
                  value="order_step.step_sequence"
                />
              </div>

              <div class="flex md4 sm6 xs12">
                <va-select
                  :label="$t('tables.mounting_flow.previous_step')"
                  v-model="order_step.previous_sequence"
                  keyBy="step_sequence"
                  textBy="name"
                  :options="order_steps"
                  searchable
                />
              </div>

              <div class="flex md4 sm6 xs12">
                <va-select
                  :label="$t('tables.mounting_flow.next_step')"
                  v-model="order_step.next_sequence"
                  keyBy="step_sequence"
                  textBy="name"
                  :options="order_steps"
                  searchable
                />
              </div>

              <!-- <div class="flex md4 sm6 xs12">
                <va-select
                  :label="$t('forms.selects.locality')"
                  v-model="order_step.locality"
                  keyBy="id"
                  textBy="name"
                  :options="listLocalities"
                />
              </div> -->
            </div>

            <div class="row">
              <div class="flex md3 sm6 xs12">
                <va-button
                  medium
                  inline
                  color="secondary"
                  icon="fa fa-save"
                  class="mr-1"
                  @click="save()"
                >
                  {{ $t('menu.update') }}
                </va-button>

                <va-button
                  medium
                  inline
                  color="#ff842b"
                  icon="fa fa-chevron-left"
                  class="ma-0"
                  :to="{ name: 'mounting-flow', params: { pallet_type_id: this.$route.params.pallet_type_id } }">
                  {{ $t('menu.back') }}
                </va-button>
              </div>
            </div>
          </form>
        </va-card>
      </div>
    </div>
  </div>  
</template>

<script>
import MountingFlowAPI from '@/services/MountingFlowAPI'
import RoleAPI from '@/services/RoleAPI'
import StatusAPI from '@/services/StatusAPI'
import OrderStepAPI from '@/services/OrderStepAPI'
import { http } from "@/services/config";
import { showError } from '@/global'
import LocalityAPI from '@/services/LocalityAPI'
import { mapState } from "vuex";

export default {
  data () {
    return {
      order_step: {
        pallet_type: {},
        status: {},
        role: {},
        previous_sequence: {
          step_sequence: '',
          name: '',
        },
        next_sequence: {
          step_sequence: '',
          name: '',
        },
        locality: {}
      },
      pallet_types: [],
      statuses: [],
      roles: [],
      order_steps: [],
      listLocalities: []
    }
  },
  computed: {
    ...mapState(["currentUser", "currentLocality"]),
  },

  mounted(){
    LocalityAPI.getAllLocalitiesWithoutLimit().then(response => {
      this.listLocalities = response.data.localities
    })
    
    StatusAPI.getAllStatuses().then(response => {
      this.statuses = response.data.statuses
    })

    RoleAPI.getRoles().then(response => {
      this.roles = response.data.roles
    })

    MountingFlowAPI.getOrderStepsByPalletType(this.$route.params.pallet_type_id, this.currentLocality.id).then(response => {
      this.order_steps = response.data.order_steps
    })
    
    if (this.$route.params.order_step_id === undefined) {
      this.order_step.pallet_type.id = this.$route.params.pallet_type_id
      this.order_step.locality.id = this.currentLocality.id
    } else {
      MountingFlowAPI.getOrderStep(this.$route.params.order_step_id).then(response => {
        this.order_step = response.data.order_step
      })
    }
  },
  methods: {
    save () {
      if ( this.$route.params.order_step_id === undefined ){
        OrderStepAPI.create(this.order_step).then(() => {
          this.goBack()
        }).catch(e => showError(e));
      } else {
        OrderStepAPI.update(this.$route.params.order_step_id, this.order_step).then(() => {
          this.goBack()
        }).catch(e => showError(e));
      }      
    },

    goBack(){
      this.$router.push({ name: 'mounting-flow', params: { pallet_type_id: this.order_step.pallet_type.id }})
    }
  }
}
</script>